import { addDays, isAfter, isBefore } from 'date-fns';
import { DailyGoal } from '@mona/models';

/** Active = goals in the current reset day; everything else is inactive. */
export function splitDailyGoals(
    goals: DailyGoal[],
    resetAt: Date,
    now = new Date(),
): { active: DailyGoal[]; inactive: DailyGoal[] } {
    const start = isAfter(now, resetAt) ? resetAt : addDays(resetAt, -1);
    const end = addDays(start, 1);

    const active: DailyGoal[] = [];
    const inactive: DailyGoal[] = [];
    for (const goal of goals) {
        (isAfter(goal.date, start) && isBefore(goal.date, end) ? active : inactive).push(goal);
    }
    return { active, inactive };
}

/** Start of the current active day (reset → next reset). */
export function activeDayStart(resetAt: Date, now = new Date()): Date {
    return isAfter(now, resetAt) ? resetAt : addDays(resetAt, -1);
}
